import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { FacebookLoginButton } from '@stepstone/social-auth-components';
import { isFacebookEnabledSelector } from '../../../core/siteConfig/siteConfigSlice.js';
import { callbackFunctionSelector, redirectionUrlSelector, } from '../../../core/sourceData/sourceDataSlice.js';
import { setErrorStatus, setShowRegistrationSuccessfulModal, } from '../../../forms/Registration/registrationSlice.js';
import { saveCandidateJustLoggedInCookie } from '../../../helpers/cookies.js';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/index.js';
import { executeCallbackFunction } from '../../../tools/callback.js';
import { redirect } from '../../../helpers/redirection.js';
import { useSendFacebookTrackingScript } from '../../../hooks/useSendFacebookTracking.js';
import { INITIAL_TRACKING_DELAY } from '../../../constants/tracking.js';
import { clearAuthError } from '../../../core/authError/authErrorSlice.js';
export const FacebookButton = ({ buttonText }) => {
    const isFacebookEnable = useAppSelector(isFacebookEnabledSelector);
    const onLoginSuccess = useAppSelector(callbackFunctionSelector);
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const handleFacebookLoginError = () => {
        dispatch(setErrorStatus(401));
    };
    const handleFacebookLoginSuccess = async ({ accountWasCreated, }) => {
        if (accountWasCreated) {
            setTimeout(() => {
                dispatch(setShowRegistrationSuccessfulModal(true));
            }, INITIAL_TRACKING_DELAY);
        }
        else {
            saveCandidateJustLoggedInCookie();
            if (onLoginSuccess) {
                await executeCallbackFunction(onLoginSuccess);
            }
            redirect(redirectionUrl);
        }
    };
    const { setTrackingEventState } = useSendFacebookTrackingScript('login');
    const sentTrackingCallbackHandler = (action) => {
        /*
          there is no way of catching facebook button click,
          so using this workaround to clear auth errors on click
        */
        if (action === 'buttonClick') {
            dispatch(clearAuthError());
        }
        setTrackingEventState(action);
    };
    return isFacebookEnable ? (_jsx(FacebookLoginButton, { a11yLabel: buttonText || t('loginregistration.login.facebookButton'), buttonText: buttonText || t('loginregistration.login.facebookButton'), onSuccess: handleFacebookLoginSuccess, onError: handleFacebookLoginError, onSendTrackingCallback: sentTrackingCallbackHandler })) : null;
};
//# sourceMappingURL=FacebookButton.js.map